import { Stack, Text } from '@chakra-ui/react'

import KhanAcademyLogo from '@/components/Icons/KhanAcademyLogo'
import ShwLink from '@/components/ShwLink'

export default function FromTheFounderOfKhanAcademy(): React.ReactElement {
  return (
    <Stack direction="row" align="center">
      <Text as="span" variant="eyebrow">
        From the Founder Of
      </Text>
      <ShwLink variant="unstyled" href="https://khanacademy.org" paddingTop="5px">
        <KhanAcademyLogo />
      </ShwLink>
    </Stack>
  )
}
